import { PluginKey } from '@tiptap/pm/state';
import { useAPIGetDataCatalogFields } from 'modules/datacatalog/api/useAPIGetDataCatalogFields';
import routes from 'modules/datacatalog/routes';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import FieldMention from 'ui/FieldMention/FieldMention';
import { FieldSuggestion } from 'ui/FieldMention/FieldSuggestion';

const fieldMentionPluginKey = new PluginKey('fieldMention');

export const useFieldMentionExtension = (
    enabled: boolean | undefined = true,
) => {
    const { data: fields } = useAPIGetDataCatalogFields(enabled);
    const navigate = useNavigate();
    const getFieldURL = (id: string) =>
        `${routes.dataCatalog}?field=${encodeURIComponent(id)}`;

    return useMemo(
        () =>
            FieldMention.configure({
                HTMLAttributes: { class: 'field-mention' },
                onFieldClick: (id: string) => navigate(getFieldURL(id)),
                renderURL: getFieldURL,
                suggestion: {
                    ...FieldSuggestion(fields),
                    pluginKey: fieldMentionPluginKey,
                },
            }),
        [fields, navigate],
    );
};
